'use client';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import ReactHtmlParser from 'react-html-parser';
import useDeviceTypeMobile from '@/components/hooks/useDeviceTypeMobile';
import BannerAds from '@/components/common/ygen/sections/banner-ads/BannerAds';
import LeftSVGScroll from '@/components/common/ui/buttons/LeftSVGScroll.jsx';
import RightSVGScroll from '@/components/common/ui/buttons/RightSVGScroll.jsx';
import { usePathname } from 'next/navigation';
import { StyledOverviewFive } from '@/components/common/ygen/sections/overview-five/over-view-five.style';

const OverviewFive = ({ data }) => {
	const isMobile = useDeviceTypeMobile()
	const pathName = usePathname()
	const [getRibonHeight, setRibonHeight] = useState(100); // Store scroll data in state

	useEffect(() => {
		const getHeight = document.querySelector('.create-top-rebon').clientHeight / 2
		setRibonHeight(getHeight)
	}, [pathName])
	return (
		<>
			<StyledOverviewFive ribon={getRibonHeight} className="OverviewFive" data-scroll-section>


				<Container>
					<Row>
						<Col md={8}>
							<p  className={'subtitle-ygen'} >
								{ReactHtmlParser(data?.section_data?.subtitle)}
							</p>
							<Title tag={'h2'} text={data?.section_data?.short_desc} color={'#000'} margin={'0 0 80px'} />
						</Col>
						<Col md={{ span: 5, offset: 1 }}>
							{ReactHtmlParser(data?.section_data?.description)}
						</Col>
					</Row>
				</Container>
				<LeftSVGScroll career/>
				<RightSVGScroll career/>
			</StyledOverviewFive>
			<BannerAds carrer data={data?.posts?.list?.[0]?.data} />

		</>
	);
};


export default React.memo(OverviewFive);
